module.exports = __webpack_public_path__ + "static/media/arrow_left.c50139df.svg";